var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupOfPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.403 7.42a1.377 1.377 0 0 1 1.368 1.218l.01.16v6.016a4.798 4.798 0 0 1-9.592.261l-.007-.261V8.798A1.377 1.377 0 0 1 7.4 7.43l.16-.01h6.843Zm0 1.378H7.56v6.016a3.421 3.421 0 0 0 6.835.224l.008-.224V8.798ZM5.176 7.42c-.2.345-.323.73-.358 1.129l-.013.248h-3.43v5.15a2.556 2.556 0 0 0 3.606 2.332c.11.453.27.887.476 1.295a3.933 3.933 0 0 1-5.45-3.396L0 13.947v-5.15A1.377 1.377 0 0 1 1.216 7.43l.161-.01h3.799Zm11.612 0h3.835a1.377 1.377 0 0 1 1.367 1.217l.01.16v5.15a3.934 3.934 0 0 1-5.487 3.615 6.12 6.12 0 0 0 .472-1.3 2.556 2.556 0 0 0 3.63-2.115l.008-.2v-5.15h-3.465l-.009-.205a2.737 2.737 0 0 0-.36-1.172ZM10.98.5a3.068 3.068 0 1 1 0 6.135 3.068 3.068 0 0 1 0-6.135Zm6.869.865a2.635 2.635 0 1 1 0 5.27 2.635 2.635 0 0 1 0-5.27Zm-13.716 0a2.635 2.635 0 1 1 0 5.27 2.635 2.635 0 0 1 0-5.27Zm6.847.512a1.69 1.69 0 1 0 0 3.381 1.69 1.69 0 0 0 0-3.38Zm6.869.865a1.258 1.258 0 1 0 0 2.517 1.258 1.258 0 0 0 0-2.517Zm-13.716 0a1.258 1.258 0 1 0 0 2.516 1.258 1.258 0 0 0 0-2.516Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOfPeople);
export default __webpack_public_path__ + "static/media/groupOfPeople.f2f88fa91480ab84605ff3bb5211d381.svg";
export { ForwardRef as ReactComponent };